import CardLessonFeed from './CardLessonFeed';

export default CardLessonFeed;
